import { useEffect } from "react";

const useControlScroll=()=>{
    useEffect(() => {
        // 禁用滚动
        document.body.style.overflow = "hidden";
        // 组件卸载时恢复滚动
        return () => {
          document.body.style.overflow = "auto";
        };
      }, []);
}
export {useControlScroll}